

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class JobTask_ManagedObject

class JobTask_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: assignedName
    set assignedName(value:string) {
        this.setValueForKey(value, 'assignedName');
    }
    get assignedName():string {
        return this.valueForKey('assignedName');
    }
    set assignedNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'assignedName');
    }
    get assignedNamePrimitiveValue():string {
        return this.primitiveValueForKey('assignedName');
    }

    // Property: dueDate
    set dueDate(value:Date) {
        this.setValueForKey(value, 'dueDate');
    }
    get dueDate():Date {
        return this.valueForKey('dueDate');
    }
    set dueDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'dueDate');
    }
    get dueDatePrimitiveValue():Date {
        return this.primitiveValueForKey('dueDate');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: notes
    set notes(value:string) {
        this.setValueForKey(value, 'notes');
    }
    get notes():string {
        return this.valueForKey('notes');
    }
    set notesPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'notes');
    }
    get notesPrimitiveValue():string {
        return this.primitiveValueForKey('notes');
    }

    // Property: reminderAt
    set reminderAt(value:Date) {
        this.setValueForKey(value, 'reminderAt');
    }
    get reminderAt():Date {
        return this.valueForKey('reminderAt');
    }
    set reminderAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'reminderAt');
    }
    get reminderAtPrimitiveValue():Date {
        return this.primitiveValueForKey('reminderAt');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Relationship: assignedTo
    protected _assignedTo:MIOManagedObjectSet = null;
    get assignedTo():MIOManagedObjectSet {
        return this.valueForKey('assignedTo');
    }
    addAssignedToObject(value:LegalEntity) {
        this._addObjectForKey(value, 'assignedTo');
    }
    removeAssignedToObject(value:LegalEntity) {
        this._removeObjectForKey(value, 'assignedTo');
    }

    // Relationship: children
    protected _children:MIOManagedObjectSet = null;
    get children():MIOManagedObjectSet {
        return this.valueForKey('children');
    }
    addChildrenObject(value:JobTask) {
        this._addObjectForKey(value, 'children');
    }
    removeChildrenObject(value:JobTask) {
        this._removeObjectForKey(value, 'children');
    }

    // Relationship: departments
    protected _departments:MIOManagedObjectSet = null;
    get departments():MIOManagedObjectSet {
        return this.valueForKey('departments');
    }
    addDepartmentsObject(value:Department) {
        this._addObjectForKey(value, 'departments');
    }
    removeDepartmentsObject(value:Department) {
        this._removeObjectForKey(value, 'departments');
    }
    // Relationship: parent
    set parent(value:JobTask) {
        this.setValueForKey(value, 'parent');
    }
    get parent():JobTask {
        return this.valueForKey('parent') as JobTask;
    }
}
